/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_home_most_liked_collections_title29 = /** @type {(inputs: {}) => string} */ () => {
	return `Liked by the community`
};

const fr_home_most_liked_collections_title29 = /** @type {(inputs: {}) => string} */ () => {
	return `Aimées par la communauté`
};

const de_home_most_liked_collections_title29 = /** @type {(inputs: {}) => string} */ () => {
	return `Beliebteste`
};

const es_home_most_liked_collections_title29 = /** @type {(inputs: {}) => string} */ () => {
	return `El más gustado`
};

const it_home_most_liked_collections_title29 = /** @type {(inputs: {}) => string} */ () => {
	return `Mi è piaciuto di più`
};

const ar_home_most_liked_collections_title29 = /** @type {(inputs: {}) => string} */ () => {
	return `الأكثر إعجابا`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const home_most_liked_collections_title29 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_most_liked_collections_title29(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("home_most_liked_collections_title29", locale)
	if (locale === "en") return en_home_most_liked_collections_title29(inputs)
	if (locale === "fr") return fr_home_most_liked_collections_title29(inputs)
	if (locale === "de") return de_home_most_liked_collections_title29(inputs)
	if (locale === "es") return es_home_most_liked_collections_title29(inputs)
	if (locale === "it") return it_home_most_liked_collections_title29(inputs)
	return ar_home_most_liked_collections_title29(inputs)
};
export { home_most_liked_collections_title29 as "HOME_MOST_LIKED_COLLECTIONS_TITLE" }